// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"13bef398","921":"8e66e1eb"}[chunkId] + ".chunk.js";
};